export const STANDARD_PLAN_MONTHLY_QUOTAS = {
  standard: 10,
  pro: 50,
  premium: 100,
  plus: 500,
  connect: 2500,
};

export function getEffectiveBillingPeriodQuota(monthlyQuota, intervalTime) {
  const quota = Number(monthlyQuota);
  if (!Number.isFinite(quota) || quota <= 0) return null;

  return intervalTime === 'EVERY_30_DAYS' ? quota : quota * 12;
}

export function getPlanDowngradeEligibility({
  currentMonthlyQuota,
  currentIntervalTime,
  usageChargeCount,
  targetMonthlyQuota,
  targetIntervalTime,
}) {
  const currentQuota = getEffectiveBillingPeriodQuota(
    currentMonthlyQuota,
    currentIntervalTime,
  );
  const targetQuota = getEffectiveBillingPeriodQuota(
    targetMonthlyQuota,
    targetIntervalTime,
  );
  const usage = Number(usageChargeCount);

  // Keep controls available until the context/plan data is ready. The server
  // validates every request, so stale client data cannot bypass the rule.
  if (
    currentQuota === null ||
    targetQuota === null ||
    !Number.isFinite(usage)
  ) {
    return { disabled: false, reason: null };
  }

  const disabled = targetQuota < currentQuota && usage > targetQuota;
  return {
    disabled,
    reason: disabled
      ? `You've used ${usage} returns this billing cycle, which exceeds this plan's ${targetQuota}-return allowance. Choose a plan with a higher allowance or wait until your next billing cycle.`
      : null,
  };
}
